<template>
    <li>
        <component
            :is="as"
            v-bind="$attrs"
            :class="{ 'bg-gray-50 text-primary': active }"
            class="flex items-center gap-x-3 py-3 px-4 font-semibold hover:bg-gray-50 text-gray-600 rounded-lg2"
        >
            <Icon
                :name="iconName"
                :class="{ 'text-primary': active }"
                class="text-gray-600 w-4 h-4"
            />
            <slot />
        </component>
    </li>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        active: {
            type: Boolean,
            default: false,
        },
        iconName: {
            type: String,
            required: true,
        },
        as: {
            type: String,
            default: 'a',
        },
    })
</script>
